export default function capitalize(value) {
  return `${value.substr(0, 1).toUpperCase()}${value.substr(1)}`;
}
